export default "__VITE_ASSET__Uygvx9kZ__"